import React from "react";

// Signed in, but no usable invitation. The message comes from the API when a key was tried.
export default function NotInvited({ reason, onTryAgain }) {
  return (
    <>
      <p className="eyebrow">Invitation needed</p>
      <h1>{reason ? "That invitation didn't work" : "You haven't been invited yet"}</h1>
      <p className="lead">{reason ?? "Registration works from the link in your invitation email. If you were expecting one, check your inbox, or ask the events team."}</p>
      <div className="card">
        <b>Events team</b><br />
        <span className="help">foodshow@liparifoods.com</span>
      </div>
      {onTryAgain && <button className="ghost" onClick={onTryAgain}>Try a different link</button>}
    </>
  );
}
